import { FC, useState } from 'react';
import { filterOptions } from 'constants/filters';
import { DashboardScreen, PageCategory, trackEvent } from 'helpers/mixpanelEvents';

interface Props {
  setFilterSelected?: (value: string) => void;
  allValue: string;
  onlyAllValue?: boolean;
  screen?: DashboardScreen;
  pageCategory?: string;
}

export const PagesFilters: FC<Props> = ({
  setFilterSelected,
  allValue,
  onlyAllValue,
  screen,
  pageCategory,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const handleSelect = (state, index) => {
    if (screen && pageCategory && index !== activeIndex) {
      trackEvent('Pages Filter Changed', {
        screen,
        page_category: pageCategory as PageCategory,
        filter: state,
      });
    }
    setActiveIndex(index);
    setFilterSelected && setFilterSelected(state);
  };

  const options = onlyAllValue ? filterOptions(allValue).slice(0, 1) : filterOptions(allValue);

  return (
    <div className="date-filter-container">
      {options.map((option, index) => (
        <button
          key={index}
          className={`date-filter-item ${activeIndex === index ? 'active' : ''}`}
          onClick={() => handleSelect(option.value, index)}
        >
          <span className="oath-body inkBlue">{option.label}</span>
        </button>
      ))}
    </div>
  );
};
